module.exports = __webpack_public_path__ + "static/media/car_directions.0efe49ba.svg";